import { Redirect, Route } from "react-router-dom";

const brandPages = [
  <Route
    exact
    key="overwolf"
    path="/overwolf"
    component={() => <Redirect to="/start" />}
  />,
  <Route
    exact
    key="allstar/gamersclub"
    path="/allstar/gamersclub"
    component={() => <Redirect to="/start" />}
  />,
];

export { brandPages };
